import React from "react";
import { FormattedMessage } from "react-intl";
import { ICON_TYPE } from "components/Icon";
import { MOVE_DIRECTION } from "constants";

export default function buildOrderedRowOptions({ item, items = [], onMove, disableMove = false }) {
  if (!item) return [];

  const index = items.findIndex((currentItem) => currentItem.id === item.id);
  const isFirst = index <= 0;
  const isLast = index === items.length - 1;

  const options = [];

  if (!disableMove && !isFirst) {
    options.push({
      label: <FormattedMessage id="Global.MoveUp" />,
      icon: ICON_TYPE.arrowUp,
      onClick: () => onMove(item.id, MOVE_DIRECTION.up),
    });
  }

  if (!disableMove && !isLast) {
    options.push({
      label: <FormattedMessage id="Global.MoveDown" />,
      icon: ICON_TYPE.arrowDown,
      onClick: () => onMove(item.id, MOVE_DIRECTION.down),
    });
  }

  return options;
}
